package devxertech.com.pages.industries.fintectIndustry

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.industries.fintectIndustry.fintechServices.FintechServices
import devxertech.com.pages.industries.fintectIndustry.fintechSolution.FintechSolutions
import devxertech.com.pages.industries.fintectIndustry.fintechSpotLight.FintechSpotLight
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/fintech-Industry")
@Composable
fun FintechIndustry() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image =   Res.Image.fintech_header,
            breakpoint = breakpoint,
            headingText = "Financial Software \n" +
                    "Development",
            descriptionText = "Fast, efficient & on-demand financial software development services"
        )
        CommonArrow("FinTech")
        FintechSolutions()
        FintechServices(breakpoint, sitePalette)
        MakeYourOwnTeam(breakpoint)
        FintechSpotLight()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}